import { Fragment, ReactNode } from "react";
import { Switch, Route } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { routes } from "../../routing/routes";
import AppBar from "../AppBar";
import Loader from "../Loader";
import Sidebar from "../Sidebar";
// import Footer from "../Footer";
import "./index.css"


type Props = {
    children: ReactNode;
};

const Layout = () => {
    const { isLoadingOverlayDisplay } = useAuth();
    return (
        <>
            {isLoadingOverlayDisplay && <Loader />}
            <div className="flex flex-col h-screen  bg-kyzzen-primary">
                <div> <AppBar /> </div>
                <div className="flex flex-row items-start">
                    <div className="w-80 h-[calc(100vh_-_80px)] overflow-y-auto small-screen"><Sidebar /></div>
                    <main
                        id="main"
                        className="w-full bg-kyzzen-primary h-[calc(100vh_-_80px)] overflow-y-auto"
                    >
                        <div className="border min-h-[calc(100vh_-_120px)] border-kyzzen-secondary rounded-xl m-4">
                            <Switch>
                                {
                                    routes?.map((route, idx) => {
                                        return route.component && (
                                            <Route
                                                key={idx}
                                                path={route.path}
                                                exact={route.exact}
                                                component={route.component}
                                            />
                                        )
                                    })
                                }
                            </Switch>
                        </div>
                    </main>
                </div>
            </div>
        </>
    );
};

export default Layout;